import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-yes-no-remarks-dialog',
  templateUrl: './yes-no-remarks-dialog.component.html',
  styleUrls: ['./yes-no-remarks-dialog.component.scss']
})
export class YesNoRemarksDialogComponent implements OnInit {

  @Input() title : string;
  @Input() content: string;
  @Input() remarks: string;
  @Input() remarksLabel: string = "Notes";


  constructor(private modal: NgbActiveModal) { }

  ngOnInit() {
  }

  yes(){
    this.modal.close({remarks: this.remarks});
  }

  close(){
    this.modal.close(false);
  }

}
